export var NgLocalStorageKey;
(function (NgLocalStorageKey) {
    NgLocalStorageKey["isManager"] = "isManager";
    NgLocalStorageKey["accountLocked"] = "accountLocked";
    NgLocalStorageKey["account"] = "account";
    NgLocalStorageKey["venue"] = "venue";
    NgLocalStorageKey["couchUsers"] = "couchUsers";
    NgLocalStorageKey["runSheetCols"] = "runSheetCols";
    NgLocalStorageKey["showEmptyTables"] = "showEmptyTables";
    NgLocalStorageKey["allBookings"] = "allBookings";
    NgLocalStorageKey["waitList"] = "waitList";
    NgLocalStorageKey["standbyList"] = "standbyList";
    NgLocalStorageKey["NBIReleaseVersion"] = "NBIReleaseVersion";
    NgLocalStorageKey["event"] = "event";
    NgLocalStorageKey["token"] = "token";
    NgLocalStorageKey["isPosActive"] = "isPosActive";
    NgLocalStorageKey["spamBooking"] = "spamBooking";
    NgLocalStorageKey["spamBookingTime"] = "spamBookingTime";
    NgLocalStorageKey["selectedDiaryView"] = "selectedDiaryView";
})(NgLocalStorageKey || (NgLocalStorageKey = {}));
/**
 * need to move all NgLocalStorageKey over to LocalStorageKey, so when they are saved in local storage they use "nbi_diary_"
 * as a prefix instead of "ng" (which is an angularJS prefix.
 */
export var LocalStorageKey;
(function (LocalStorageKey) {
    LocalStorageKey["account"] = "account";
    LocalStorageKey["token"] = "token";
    LocalStorageKey["isLegacyLogin"] = "isLegacyLogin";
    LocalStorageKey["authorisationServer"] = "authorisationServer";
    LocalStorageKey["client"] = "client";
    LocalStorageKey["redirectUri"] = "redirectUri";
    LocalStorageKey["codeVerifier"] = "codeVerifier";
    LocalStorageKey["accessToken"] = "accessToken";
    LocalStorageKey["refreshToken"] = "refreshToken";
    LocalStorageKey["idToken"] = "idToken";
    LocalStorageKey["countries"] = "countries";
    LocalStorageKey["pointerType"] = "pointerType";
})(LocalStorageKey || (LocalStorageKey = {}));
